import { render, staticRenderFns } from "./userWizard.vue?vue&type=template&id=362796fa&"
import script from "./userWizard.vue?vue&type=script&lang=js&"
export * from "./userWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports